module.exports = __webpack_public_path__ + "images/euromobil_smalle5342fa88626fc1f3fca7e5755ed35a6.png";